import styled from 'styled-components';

export const FooterWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: 600;
`;
